import { camelCase } from "lodash";
import { thor } from "../typings/thor";

interface SearchResult {
    items: Object[];
    total: number;
    moreResults: boolean;
    call: number;
}

export class LokiFilterService {
    public static $inject: string[] = [
        "$log",
        "$q",
        "configService",
        "lokiSearchService"
    ];

    private static DEFAULT_SEARCH_RESULT_VALUE: SearchResult = {
        items: [],
        total: 0,
        moreResults: false,
        call: 0
    };

    public context;
    public filterParams: thor.SearchFilterParams;
    public futureSales: SearchResult;
    public futureItems: SearchResult;
    public isSearching;
    public pastItems: SearchResult;
    public pastSales: SearchResult;
    public sortParams;

    constructor(
        private $log: ng.ILogService,
        private $q: ng.IQService,
        private configService,
        private searchService
    ) {
        this.setFilterParams();

        this.isSearching = false;
        this.sortParams = {
            field: "sale.datetime",
            reverse: true
        };
        this.futureItems = LokiFilterService.DEFAULT_SEARCH_RESULT_VALUE;
        this.futureSales = LokiFilterService.DEFAULT_SEARCH_RESULT_VALUE;
        this.pastItems = LokiFilterService.DEFAULT_SEARCH_RESULT_VALUE;
        this.pastSales = LokiFilterService.DEFAULT_SEARCH_RESULT_VALUE;
    }

    public resetAll() {
        this.setFilterParams();
    }

    public resetSearch() {
        this.filterParams.query = "";
    }

    public search() {
        let promise;
        const context = camelCase(this.context);
        const searchFunction = camelCase(`search-${ this.context }`);

        this.isSearching = true;

        // Organizations' search is client side
        // So add an exception
        if (this.context === "organizations") {
            this.isSearching = false;
            return this.$q.resolve();
        }

        if (typeof this.searchService[searchFunction] !== "function") {
            return this.$q.reject(`Unhandled context ${ this.context }`);
        }

        promise = this.searchService[searchFunction](
            this.filterParams,
            this.sortParams,
            0,
            this.configService.pagination.low
        )
            .then(result => this[context] = result)
            .catch(error => {
                this.$log.error(`Error while searching "${ this.context }"`, error);
            })
            .finally(() => {
                this.isSearching = false;
            });

        return promise;
    }

    public searchMore() {
        let promise;
        const context = camelCase(this.context);
        const searchMethod = camelCase(`search-${ this.context }`);
        const resultContext = this[context];

        if (!resultContext || typeof this.searchService[searchMethod] !== "function") {
            return this.$q.reject(`Unhandled context ${ this.context }`);
        }

        resultContext.call++;
        promise = this.searchService[searchMethod](
            this.filterParams,
            this.sortParams,
            resultContext.call,
            this.configService.pagination.low
        )
            .then(result => {
                resultContext.items = resultContext.items.concat(result.items);
                resultContext.total = result.total;
                resultContext.moreResults = result.moreResults;
            });

        return promise;
    }

    public setContext(context) {
        this.context = context;
    }

    private setFilterParams() {
        this.filterParams = { query: "", organization: "" };
    }
}
